var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-select',_vm._g({staticClass:"virtual-select-custom-style",attrs:{"popper-class":"virtualselect","value":_vm.defaultValue,"filterable":"","filter-method":_vm.filterMethod,"default-first-option":"","clearable":"","placeholder":_vm.placeholder,"disabled":_vm.disabled,"multiple":_vm.isMultiple,"allow-create":_vm.allowCreate},on:{"visible-change":_vm.visibleChange,"clear":_vm.clearChange}},_vm.$listeners),[_c('virtual-list',{ref:"virtualList",staticClass:"virtualselect-list",attrs:{"data-key":_vm.value,"data-sources":_vm.selectArr,"data-component":_vm.itemComponent,"keeps":_vm.keepsParams,"extra-props":{
        label: _vm.label,
        value: _vm.value,
        isRight: _vm.isRight,
        isConcat: _vm.isConcat,
        concatSymbol: _vm.concatSymbol
      }}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bfa29812","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/myComponents/VirtualSelect.vue
// module id = null
// module chunks = 